import React from "react"

const Reiseverlauf = (props) => (
  <div className="reiseverlauf">
    {props.reiseverlauf.map((tag, index) => (
      <div key={index} className="reiseverlauf-tag">
        <div className="reiseverlauf-tag-title">{tag.title}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: tag.text.childMarkdownRemark.html,
          }}
        ></div>
      </div>
    ))}
  </div>
)
export default Reiseverlauf
